import styled from 'styled-components';

export const SpinnerLoader = styled.div`
  display: block;
  position: relative;
  letter-spacing: 0.5px;

  .spinner::after {
    content: '';
    box-sizing: border-box;
    width: ${(props) =>
      `clamp(${props.mobileWidth}, 4vw, ${props.desktopWidth})`};
    height: ${(props) =>
      `clamp(${props.mobileHeight}, 4vw, ${props.desktopHeight})`};
    position: absolute;
    top: ${(props) => `calc(50% - ${props.topExtraMargin})`};
    left: calc(50% - 8px);
    border-radius: 50%;
  }

  .spinner.smooth::after {
    border-top: 2px solid ${(props) => props.spinColor || 'rgb(239 78 94)'};
    border-left: 2px solid ${(props) => props.spinColor || 'rgb(239 78 94)'};
    border-right: 2px solid rgba(255, 255, 255, 0);
    animation: spinner 1.4s linear infinite;
  }

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
`;

export const SearchLoaderContainer = styled.div`
  padding: 30px 0;
`;
